import React from 'react';
import { useBrand } from '@/context/BrandContext';
import { EditableText } from '../ui/EditableText';
import { BrandSectionLayout } from './BrandSectionLayout';

interface BrandLogoCoverSectionProps {
  section: any;
  isEditing: boolean;
  isGlobalDarkMode: boolean;
  editingElement: string | null;
  setEditingElement: (element: string | null) => void;
  updateSectionContent: (key: string, value: string) => void;
  updateSectionStyles: (key: string, styles: any) => void;
  pageNumber?: number;
}

export const BrandLogoCoverSection: React.FC<BrandLogoCoverSectionProps> = ({
  section,
  isEditing,
  isGlobalDarkMode,
  editingElement,
  setEditingElement,
  updateSectionContent,
  updateSectionStyles,
  pageNumber = 1
}) => {
  const { state } = useBrand();

  // Get primary color from brand data
  const primaryColor = state.brandData?.colors?.primary || '#3B82F6';

  return (
    <BrandSectionLayout
      section={section}
      isEditing={isEditing}
      isGlobalDarkMode={isGlobalDarkMode}
      editingElement={editingElement}
      setEditingElement={setEditingElement}
      updateSectionContent={updateSectionContent}
      updateSectionStyles={updateSectionStyles}
      pageNumber={pageNumber}
      showPageNumber={true}
      isCoverPage={true}
    >
      {/* Main flex container with full height */}
      <div className="h-full flex items-center">
        <EditableText
          value={section.content.coverTitle || 'LOGO'}
          onChange={(value) => updateSectionContent('coverTitle', value)}
          element="h1"
          className="text-8xl font-bold leading-tight tracking-tight text-white"
          placeholder="LOGO"
          multiline={true}
          editModeEnabled={isEditing}
          isEditing={isEditing && editingElement === 'coverTitle'}
          onEditStart={() => setEditingElement('coverTitle')}
          onEditEnd={() => setEditingElement(null)}
          onStyleChange={(styles) => updateSectionStyles('coverTitle', styles)}
          initialStyles={{
            fontFamily: state.brandData?.globalTitleFont || 'Inter',
            color: '#ffffff',
            textTransform: 'uppercase',
            ...section.content.coverTitleStyles
          }}
          isGlobalDarkMode={isGlobalDarkMode}
          sectionBackgroundColor={primaryColor}
        />
      </div>
    </BrandSectionLayout>
  );
};
